<template>
  <v-navigation-drawer
    class="elevation-8 main-menu-panel"
    hide-overlay
    fixed
    expand-on-hover
    :mini-variant-width="80"
    :width="325"
    :mini-variant.sync="mini"
    touchless
    permanent
  >
    <main-menu-header />
    <v-list style="white-space:nowrap; width: 325px;">
      <main-menu-admin v-if="isAdminUser" />
      <main-menu-standalone v-if="!isWnbUser && !isAdminUser" />
      <v-list-item to="/logout" v-if="is_user_logged()" style="border-top: 1px solid rgba(0,0,0,.12);">
        <v-list-item-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-item-action>
        <v-list-item-content>{{ $t("global.menu.logOut") }}</v-list-item-content>
      </v-list-item>
    </v-list>
    <main-menu-w-n-b v-if="isWnbUser && !isAdminUser" />
  </v-navigation-drawer>
</template>

<script>
import MainMenuHeader from "./MenuHeader.vue";
import MainMenuStandalone from "./MenuStandalone.vue";
import MainMenuWNB from "./MenuWNB.vue";
import MainMenuAdmin from "./MenuAdmin";

export default {
  name: "MainMenu",
  components: {
    MainMenuAdmin,
    MainMenuWNB,
    MainMenuStandalone,
    MainMenuHeader
  },
  data() {
    return {
      right: null,
      mini: true,
      drawer: true,
      app: "app",
      hover: null,
      name: null,
      nameRules: null
    };
  },
  computed: {
    isLoggedAs() {
      return this.$store.getters.userProperties != null && typeof this.$store.getters.userProperties.context_user_login !== "undefined";
    },
    can_user_login_as_menu: function() {
      if (typeof this.$store.getters.userProperties !== "undefined" && this.$store.getters.userProperties != null) {
        return this.$store.getters.userProperties.can_login_as;
      }
      return false;
    },
    hasPermissionForInvoices() {
      return this.$store.getters.hasPermission("viewInvoices");
    },
    hasPermissionForBookings() {
      return this.$store.getters.hasPermission("viewBookings");
    },
    isWnbUser() {
      return this.$store.getters["isWnbUser"];
    },
    isAdminUser() {
      return this.$store.getters["isAdmin"];
    }
  },
  methods: {
    is_user_logged: function() {
      return this.$store.getters.isAuthenticated;
    },
    loginBack: function() {
      this.$store.dispatch("AUTH_LOGIN_BACK");
    }
  }
};
</script>

<style>
.navigation-drawer--temporary .v-list-item__action {
  padding-left: 12px;
}

.v-list-item__action {
  padding-left: 12px;
  text-align: left !important;
}

/*.v-navigation-drawer--mini-variant .v-list-item__action {*/
/*  padding-left: unset;*/
/*}*/

.main-menu-panel {
  z-index: 8;
  margin-bottom: 36px;
  width: 80px;
}
</style>

<style scoped>
.v-list-item {
  justify-content: left !important;
}
</style>
